export default "__VITE_ASSET__u5DZg0Ct__"